import { useEffect } from "react";
import { getDynamicIds } from "./getData";

const GoogleTagManager = () => {
  useEffect(() => {
    const { paisId, cadenaId } = getDynamicIds();
    // GTM ID por país
    const gtmIds = { 
      1: { //GMO
        2: 'GTM-KM53F7D', //Chile
        4: 'GTM-PVNKHZL', //Ecuador
        3: 'GTM-KM7NZ35', //Colombia
        1: 'GTM-T4P8487' //Peru
      },
      2: { //Econoptica
        2: 'GTM-NTBN9KH' //Chile
      },
      5: { //OPV
        2: 'GTM-WS37MKH' //Chile
      }
    };

    const id = gtmIds[cadenaId];

    if (id && cadenaId && paisId) {
      const script = document.createElement("script");
      script.innerHTML = `
        (function(w,d,s,l,i){
          w[l]=w[l]||[];
          w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
          var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
          j.async=true;
          j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
          f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${id[paisId]}');
      `;
      document.head.appendChild(script);

      const noscript = document.createElement("noscript");
      noscript.innerHTML = `
        <iframe src="https://www.googletagmanager.com/ns.html?id=${id}" height="0" width="0" style="display:none;visibility:hidden"></iframe>
      `;
      document.body.appendChild(noscript);

      return () => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
        if (noscript.parentNode) {
          noscript.parentNode.removeChild(noscript);
        }
      };
    }
  }, []);

  return null;
};

export default GoogleTagManager;
